import { inject, Injector } from '@angular/core';
import { HttpEvent, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { HealthMetricService } from '@lentau/analytics/health-metrics/service';

export function healthMetricInterceptor(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  req: HttpRequest<any>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  next: (req: HttpRequest<any>) => Observable<HttpEvent<any>>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<HttpEvent<any>> {
  const injector: Injector = inject(Injector);
  return next(req).pipe(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    switchMap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        return handleHealthMetricSuccess(event, req, injector);
      }

      return of(event);
    }),
    catchError((response: HttpErrorResponse) => {
      return handleHealthMetricError(response, req, injector);
    })
  );
}

export function handleHealthMetricSuccess(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event: HttpResponse<any>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  req: HttpRequest<any>,
  injector: Injector
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<HttpEvent<any>> {
  const healthMetricService: HealthMetricService = injector.get(HealthMetricService);
  healthMetricService.handleSuccess(event, req);

  return of(event);
}

export function handleHealthMetricError(
  err: HttpErrorResponse,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  req: HttpRequest<any>,
  injector: Injector
): Observable<never> {
  const healthMetricService: HealthMetricService = injector.get(HealthMetricService);
  healthMetricService.handleError(err, req);
  return throwError(() => err);
}
